// Every link this used to render (Chart of Accounts, Ledger Explorer, PDC,
// Item Master, ...) already exists in the left sidebar under "Accounting" —
// this in-page title/badge/tab-strip was a second door to the same screens,
// just duplicating the sidebar. Removed at the source so every page that
// renders <AccountingSubNav /> loses it in one place instead of N edits.
export function AccountingSubNav() {
  return null;
}

export default AccountingSubNav;
